/**
 * Sets a cookie with the given name, value, and expiration days.
 *
 * @param {string} cname - The name of the cookie.
 * @param {string} cvalue - The value to be stored in the cookie.
 * @param {number} exdays - The number of days until the cookie expires.
 */
export function setCookie(cname: string, cvalue: string, exdays: number) {
  var d = new Date()
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
  var expires = 'expires=' + d.toUTCString()
  document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
}

/**
 * Retrieves the value of a cookie with the given name.
 *
 * @param {string} cname - The name of the cookie to retrieve.
 * @returns {string} - The value of the cookie, or an empty string if the cookie is not found.
 */
export function getCookie(cname: string) {
  var name = cname + '='
  var decodedCookie = decodeURIComponent(document.cookie)
  var ca = decodedCookie.split(';')
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i]
    while (c.charAt(0) == ' ') {
      c = c.substring(1)
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length)
    }
  }
  return ''
}

/**
 * Deletes a cookie with the given name.
 *
 * @param {string} name - The name of the cookie to delete.
 */
export function deleteCookie(name: string) {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;'
}
